import { observable } from 'mobx';

export type MileageNumberResponseArgs = {
  id?: number;
  carrier?: string;
  number?: string;
};

export type MileageNumberArgs = {
  id?: number;
  carrier?: string;
  number?: string;
};

export const convertMileageNumberResponseToArgs = (response: MileageNumberResponseArgs) => {
  const args: MileageNumberArgs = {
    id: response.id,
    carrier: response.carrier,
    number: response.number
  };
  return args;
};

export default class MileageNumber {
  @observable id?: number;
  @observable carrier?: string;
  @observable number?: string;

  constructor(args: MileageNumberArgs) {
    this.id = args.id;
    this.carrier = args.carrier;
    this.number = args.number;
  }
}
